<template>
  <div class="info-page">
    <Crumbs title="创业导师管理" />
    <el-form
      :model="form"
      :rules="rules"
      ref="ruleForm"
      label-position="right"
      label-width="100px"
    >
      <div class="info-page__item">
        <div class="info-page__title">
          <span>导师信息</span>
        </div>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="导师类型" prop="expertType">
              <enumerate
                v-model="form.expertType"
                url="/api/expert/getexperttype"
                placeholder="请选择导师类型"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="导师姓名" prop="name">
              <el-input
                v-model="form.name"
                placeholder="请输入导师姓名"
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="导师头像" prop="imgUploadList">
              <!-- :rules="{ required: true, message: '请上传导师头像' }" -->
              <image-upload
                url="/api/expert/uploadreqimfile"
                accept="image/jpeg,image/png,image/bmp"
                :file-list.sync="form.imgUploadList"
                :multiple="false"
                :num-limit="1"
                :size-limit="10"
              >
                <template>
                  <el-alert
                    :title="`上传图片格式要求 jpg、jpeg、bmp、png；每个大小不超过10MB；图片名(包含后缀名)的最大长度为100个字符。`"
                    type="warning"
                  >
                  </el-alert>
                </template>
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="学历信息" prop="education">
              <el-input
                v-model="form.education"
                placeholder="请输入学历信息"
                maxlength="20"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="10"
          v-for="(item, index) in form.zhiCheng"
          :key="'zhiCheng' + index"
        >
          <el-col :span="8">
            <el-form-item
              :label="index === 0 ? '职称信息' : ''"
              :prop="`zhiCheng[${index}]`"
              :rules="{ required: true, message: '请输入职称信息' }"
            >
              <el-input
                v-model="form.zhiCheng[index]"
                placeholder="请输入职称信息"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <template v-if="index === form.zhiCheng.length - 1">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                :disabled="zhiChengHasEmpty"
                @click.prevent="addItem(form.zhiCheng, 4)"
              ></el-button>
            </template>
            <template v-else>
              <el-button
                plain
                type="warning"
                icon="el-icon-minus"
                circle
                @click.prevent="removeItem(form.zhiCheng, index)"
              ></el-button>
            </template>
          </el-col>
        </el-row>
        <el-row
          :gutter="10"
          v-for="(item, index) in form.services"
          :key="'services' + index"
        >
          <el-col :span="8">
            <el-form-item
              :label="index === 0 ? '服务信息' : ''"
              :prop="`services[${index}]`"
              :rules="{ required: true, message: '请输入服务信息' }"
            >
              <el-input
                v-model="form.services[index]"
                placeholder="请输入服务信息"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <template v-if="index === form.services.length - 1">
              <el-button
                plain
                type="primary"
                icon="el-icon-plus"
                circle
                :disabled="servicesHasEmpty"
                @click.prevent="addItem(form.services, 4)"
              ></el-button>
            </template>
            <template v-else>
              <el-button
                plain
                type="warning"
                icon="el-icon-minus"
                circle
                @click.prevent="removeItem(form.services, index)"
              ></el-button>
            </template>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item label="导师简介" prop="description">
              <editor
                v-model="form.description"
                imgUploadUrl="/api/expert/uploadreqimfile"
              ></editor>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="submit fn-text-center mt-20">
      <template v-if="isAdd">
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </template>
      <template v-else>
        <el-button
          type="primary"
          :loading="isLoading"
          plain
          @click="handlerModifyData('ruleForm')"
          >提交</el-button
        >
      </template>
    </div>
  </div>
</template>

<script>
import CheckObj from "@/utils/check.js";
export default {
  name: "teacherInfo",
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      // 是否处于loading状态
      isLoading: false,
      //是添加数据还是修改数据
      isAdd: true,
      //表单
      form: {
        expertType: "", // integer
        name: "",
        education: "",
        description: "",
        imgUploadList: [], // imageUrl 相对应
        services: [""],
        zhiCheng: [""]
      },
      rules: {
        expertType: [isEmpty("请选择导师类型", "change")],
        name: [
          isEmpty("请输入导师姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请输入正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        education: [isEmpty("请输入学历信息")],
        description: [isEmpty("请输入导师简介")],
        imgUploadList: [isEmpty("请上传导师头像", "change")]
      }
    };
  },
  computed: {
    // 服务信息是否有空项目
    servicesHasEmpty() {
      return this.form.services.some((item) => {
        return item === "";
      });
    },
    // 职称信息是否有空项目
    zhiChengHasEmpty() {
      return this.form.zhiCheng.some((item) => {
        return item === "";
      });
    }
  },
  created() {
    const { method } = this.$route.params;
    // 默认值 走添加流程
    let isAdd = true;
    if (method === "modification") {
      //获取信息
      this.loadInfo();
      //走修改流程
      isAdd = false;
    }
    this.isAdd = isAdd;
  },
  methods: {
    // 职称、服务 添加删除一项
    addItem(list, limit) {
      if (limit && list.length >= limit) return;
      list.push("");
    },
    removeItem(list, index) {
      list.splice(index, 1);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const {
        // integer
        expertType,
        // list
        imgUploadList,
        services,
        zhiCheng,
        ...others
      } = this.form;
      // 处理上传文件
      const deconstruct = (file = {}) => {
        return file.response ? file.response.dataList[0].url : file.url || "";
      };
      const imageUrl = deconstruct(imgUploadList[0]);
      // 处理字符串 转为数字
      const turnNumber = {
        expertType
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === "" ? -1 : turnNumber[key];
      });
      return {
        ...others,
        ...turnNumber,
        imageUrl,
        services: services.filter((item) => {
          return item !== "";
        }),
        zhiCheng: zhiCheng.filter((item) => {
          return item !== "";
        })
      };
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      const {
        // -1 => ""
        expertType,
        // 去分号
        imageUrl,
        ...others
      } = data;
      // 处理文件
      const turnFile = {
        imgUploadList: imageUrl
      };
      Object.keys(turnFile).map((key) => {
        const file = this.turnNulltoString(turnFile[key]);
        turnFile[key] =
          file === ""
            ? []
            : [
                {
                  url: file
                }
              ];
      });
      // 处理数字 转为字符串
      const turnNumber = {
        expertType
      };
      Object.keys(turnNumber).map((key) => {
        turnNumber[key] = turnNumber[key] === -1 ? "" : turnNumber[key];
      });

      return {
        ...others,
        ...turnNumber,
        ...turnFile
      };
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 点击修改数据按钮
    handlerModifyData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadModifyData();
        }
      });
    },

    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("mentor", "addTeacher", params).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },
    // 加载修改数据接口
    loadModifyData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      const { id } = this.$route.query;
      this.$api("mentor", "modifyTeacher", {
        ...params,
        id
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.redirectTo();
        }
      });
    },

    // 加载数据接口
    loadInfo() {
      const { id } = this.$route.query;
      this.$api("mentor", "getInfo", { id }).then((res) => {
        const { code, message } = res;
        if (code === 0) {
          this.form = this.downloadProcessData(res.dataList[0]);
        } else {
          this.$message.error(message);
          this.redirectTo();
        }
      });
    },
    // 返回列表页
    redirectTo() {
      this.redirectByPath(`/admin/mentorManage/teacherList`);
    }
  }
};
</script>

<style lang="less" scoped></style>
